module.exports = __webpack_public_path__ + "static/media/unsave.338d1cb7.svg";